import { FIRECMS_LOCALE_STORAGE_KEY } from "@firecms/core";
import type { Locale } from "../localization/constants";
import { normalizeFireCMSLocale } from "./adminLocales";

/**
 * Current admin UI locale (FireCMS language selector / localStorage).
 * For use outside React hooks when building collections or similar.
 */
export function getAdminUiLocale(): Locale {
  if (typeof window === "undefined") {
    return "en";
  }
  const stored =
    localStorage.getItem(FIRECMS_LOCALE_STORAGE_KEY) ?? undefined;
  return normalizeFireCMSLocale(stored);
}
